// import { push } from 'react-router-redux';
// import gaPush, { gaSetUser } from '../globs/utils/google-analytics';
import ajaxProxy from '../globs/ajax-proxy';
import { unsubscribeNotifications } from './firebase-notifications';

export default function appLogout({ url, user }) {
  // gaSetUser(); // Reset the GA user id
  // gaPush('event', {
  //   category: 'Login',
  //   action: 'Logout',
  // });
  console.log('url==>', url, user);
  return (dispatch) => {
    unsubscribeNotifications(user).then(() => {
      ajaxProxy
      .appLogout({ url })
      .then((response) => {
        dispatch(dataLoadFulfilled(response));
        window.localStorage.clear();
        window.location.reload();
        window.location.replace('/login');
      })
      .catch((errResponse) => {
        dispatch(logout());

        const shouldInvalidateSession = errResponse &&
          errResponse.response &&
          (errResponse.response.status === 403 || errResponse.response.status === 401);

        if (shouldInvalidateSession) {
          dispatch(logout());
          window.localStorage.clear();
          window.location.replace('/login');
        }
      });
    });
  };
}
// i need to do things for when api status code is not equal to 200 
function logout() {
  return {
    type: 'app/logout',
    payload: {},
  };
}

function appReset() {
  return {
    type: 'app/reset',
    payload: {},
  };
}

function dataLoadFulfilled (response) {
  return {
    type: 'data-Load_Fulfilled',
    payload: response,
  };
}